import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, ResultEmpty, Result, ResultSuccess } from '@headless-workspace/core-domain';
import { LanguageHelpers } from '@headless-workspace/utils';
import { MiniSizeConfigDTO } from './MiniSizeConfigDTO';
import { MiniSizeConfigValue } from './MiniSizeConfigValue';

export const MINI_SIZE_CONFIG_KEY = 'miniSizeJSON';

type GetMiniSizeConfig = Promise<Result<MiniSizeConfigValue>>;

export interface MiniSizeConfigRepositorySpec {
    getMiniSizeConfig(locale: Locale): GetMiniSizeConfig;
}
export class MiniSizeConfigRepository extends ConfigByKeyRepository implements MiniSizeConfigRepositorySpec {
    async getMiniSizeConfig(locale: Locale): GetMiniSizeConfig {
        const miniSizeConfigResult = await this.getConfigByKey(MINI_SIZE_CONFIG_KEY, { locale }, (value) =>
            MiniSizeConfigDTO.parse(value),
        );

        if (miniSizeConfigResult.type !== 'success') {
            return ResultEmpty();
        }

        const language = LanguageHelpers.parseLanguage(locale);

        const miniSizeConfig = miniSizeConfigResult.data[language];

        return ResultSuccess(miniSizeConfig);
    }
}
